import {getCurrentUserLogin} from '@github-ui/client-env'
import {MergeBoxWithSuspense, MergeMethodContextProvider, validateMergeMethod} from '@github-ui/mergebox'
import {useLayoutRouteData} from '../../../page-data/loaders/use-layout-route-data'
import {MergeMethod} from '@github-ui/mergebox/types'
import {OVERVIEW_MERGE_BOX_ANCHOR_ID} from '../../../helpers/constants'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import styles from './OverviewMergeBox.module.css'
import {isMiniMergeboxEnabled} from './is-mini-mergebox-enabled'

// Note - we have an opportunity to consolidate this with the MergeBoxWrapper in the Conversations route,
// but for now we keep them separate to avoid introducing risk to the Conversations route while we iterate.

// We also intentionally are not using useMergeStatusButtonData here because that hook specifically filters out
// scenarios for header merge button rendering. We want the same experience between Conversation and Overview.

export function OverviewMergeBox() {
  const viewerLogin = getCurrentUserLogin()
  const {mergeStatusButtonData} = useLayoutRouteData()

  // TODO - handle locked state like Conversation does
  if (!mergeStatusButtonData || !viewerLogin) {
    return null
  }

  if (isMiniMergeboxEnabled()) {
    return null
  }

  const {channels, helpUrl, defaultMergeMethod} = mergeStatusButtonData
  const mergeMethod = validateMergeMethod(defaultMergeMethod) ? defaultMergeMethod : MergeMethod.MERGE
  const showUpdatedHeader = isFeatureEnabled('updated_pull_request_header')

  return (
    <MergeMethodContextProvider defaultMergeMethod={mergeMethod}>
      <div
        id={OVERVIEW_MERGE_BOX_ANCHOR_ID}
        tabIndex={-1}
        role="region"
        aria-label="Merge status"
        data-testid="mergebox-partial"
        className={showUpdatedHeader ? styles.anchorWithScrollMargin : undefined}
      >
        <MergeBoxWithSuspense channels={channels} helpUrl={helpUrl} viewerLogin={viewerLogin} hideIcon />
      </div>
    </MergeMethodContextProvider>
  )
}
